import api from "./Api";

class EmitenteRestricaoPadraoService {
  GetEmitenteRestricaoPadrao(payload) {
    return api
      .get("/v1/emitenteRestricaoPadrao/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostEmitenteRestricaoPadrao(payload) {
    return api
      .post("/v1/emitenteRestricaoPadrao/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutEmitenteRestricaoPadrao(payload) {
    return api.put("/v1/emitenteRestricaoPadrao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEmitenteRestricaoPadrao(payload) {
    return api
      .delete("/v1/emitenteRestricaoPadrao/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetEmitenteRestricaoPadraoOData(payload) {
    return api
      .get("/OData/EmitenteRestricaoPadrao" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new EmitenteRestricaoPadraoService();
